/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  PaginatedPlaylistBackgroundVideoList,
  PlaylistBackgroundVideo,
  PlaylistBackgroundVideoBulkDeleteRequest,
  PlaylistBackgroundVideoReorderRequest,
  PlaylistBackgroundVideoRequest,
  PlaylistBackgroundVideosParams,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 플레이리스트의 모든 배경 영상을 순서대로 조회합니다.
 * @summary 배경 영상 목록 조회
 */
export const playlistBackgroundVideos = (
  playlistPk: string,
  params?: PlaylistBackgroundVideosParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedPlaylistBackgroundVideoList>(
    {
      url: `/api/playlists/${playlistPk}/background-videos/`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getPlaylistBackgroundVideosQueryKey = (
  playlistPk?: string,
  params?: PlaylistBackgroundVideosParams,
) => {
  return [
    `/api/playlists/${playlistPk}/background-videos/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlaylistBackgroundVideosQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistBackgroundVideos>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params?: PlaylistBackgroundVideosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundVideos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlaylistBackgroundVideosQueryKey(playlistPk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistBackgroundVideos>>
  > = ({ signal }) =>
    playlistBackgroundVideos(playlistPk, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!playlistPk,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistBackgroundVideos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistBackgroundVideosQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistBackgroundVideos>>
>;
export type PlaylistBackgroundVideosQueryError = ErrorType<unknown>;

export function usePlaylistBackgroundVideos<
  TData = Awaited<ReturnType<typeof playlistBackgroundVideos>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params: undefined | PlaylistBackgroundVideosParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundVideos>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistBackgroundVideos>>,
          TError,
          Awaited<ReturnType<typeof playlistBackgroundVideos>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistBackgroundVideos<
  TData = Awaited<ReturnType<typeof playlistBackgroundVideos>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params?: PlaylistBackgroundVideosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundVideos>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistBackgroundVideos>>,
          TError,
          Awaited<ReturnType<typeof playlistBackgroundVideos>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistBackgroundVideos<
  TData = Awaited<ReturnType<typeof playlistBackgroundVideos>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params?: PlaylistBackgroundVideosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundVideos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 배경 영상 목록 조회
 */

export function usePlaylistBackgroundVideos<
  TData = Awaited<ReturnType<typeof playlistBackgroundVideos>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  params?: PlaylistBackgroundVideosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundVideos>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistBackgroundVideosQueryOptions(
    playlistPk,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트에 배경 영상을 업로드합니다.

**자동 처리:**
- 첫 프레임에서 320x180 썸네일 자동 생성
- 영상 길이 자동 감지

**지원 형식:** MP4, WebM, MOV (최대 100MB)
 * @summary 배경 영상 업로드
 */
export const playlistBackgroundVideos2 = (
  playlistPk: string,
  playlistBackgroundVideoRequest: BodyType<PlaylistBackgroundVideoRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistBackgroundVideo>(
    {
      url: `/api/playlists/${playlistPk}/background-videos/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: playlistBackgroundVideoRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistBackgroundVideos2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistBackgroundVideos2>>,
    TError,
    { playlistPk: string; data: BodyType<PlaylistBackgroundVideoRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistBackgroundVideos2>>,
  TError,
  { playlistPk: string; data: BodyType<PlaylistBackgroundVideoRequest> },
  TContext
> => {
  const mutationKey = ["playlistBackgroundVideos2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistBackgroundVideos2>>,
    { playlistPk: string; data: BodyType<PlaylistBackgroundVideoRequest> }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistBackgroundVideos2(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistBackgroundVideos2MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistBackgroundVideos2>>
>;
export type PlaylistBackgroundVideos2MutationBody =
  BodyType<PlaylistBackgroundVideoRequest>;
export type PlaylistBackgroundVideos2MutationError = ErrorType<unknown>;

/**
 * @summary 배경 영상 업로드
 */
export const usePlaylistBackgroundVideos2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistBackgroundVideos2>>,
      TError,
      { playlistPk: string; data: BodyType<PlaylistBackgroundVideoRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistBackgroundVideos2>>,
  TError,
  { playlistPk: string; data: BodyType<PlaylistBackgroundVideoRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistBackgroundVideos2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 특정 배경 영상의 상세 정보를 조회합니다.
 * @summary 배경 영상 상세 조회
 */
export const playlistBackgroundVideos4 = (
  playlistPk: string,
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistBackgroundVideo>(
    {
      url: `/api/playlists/${playlistPk}/background-videos/${id}/`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getPlaylistBackgroundVideos4QueryKey = (
  playlistPk?: string,
  id?: string,
) => {
  return [`/api/playlists/${playlistPk}/background-videos/${id}/`] as const;
};

export const getPlaylistBackgroundVideos4QueryOptions = <
  TData = Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlaylistBackgroundVideos4QueryKey(playlistPk, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistBackgroundVideos4>>
  > = ({ signal }) =>
    playlistBackgroundVideos4(playlistPk, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(playlistPk && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistBackgroundVideos4QueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistBackgroundVideos4>>
>;
export type PlaylistBackgroundVideos4QueryError = ErrorType<unknown>;

export function usePlaylistBackgroundVideos4<
  TData = Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
          TError,
          Awaited<ReturnType<typeof playlistBackgroundVideos4>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistBackgroundVideos4<
  TData = Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
          TError,
          Awaited<ReturnType<typeof playlistBackgroundVideos4>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistBackgroundVideos4<
  TData = Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 배경 영상 상세 조회
 */

export function usePlaylistBackgroundVideos4<
  TData = Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
  TError = ErrorType<unknown>,
>(
  playlistPk: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistBackgroundVideos4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistBackgroundVideos4QueryOptions(
    playlistPk,
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 특정 배경 영상을 삭제합니다.
 * @summary 배경 영상 삭제
 */
export const playlistBackgroundVideos3 = (
  playlistPk: string,
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${playlistPk}/background-videos/${id}/`,
      method: "DELETE",
    },
    options,
  );
};

export const getPlaylistBackgroundVideos3MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistBackgroundVideos3>>,
    TError,
    { playlistPk: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistBackgroundVideos3>>,
  TError,
  { playlistPk: string; id: string },
  TContext
> => {
  const mutationKey = ["playlistBackgroundVideos3"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistBackgroundVideos3>>,
    { playlistPk: string; id: string }
  > = (props) => {
    const { playlistPk, id } = props ?? {};

    return playlistBackgroundVideos3(playlistPk, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistBackgroundVideos3MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistBackgroundVideos3>>
>;

export type PlaylistBackgroundVideos3MutationError = ErrorType<unknown>;

/**
 * @summary 배경 영상 삭제
 */
export const usePlaylistBackgroundVideos3 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistBackgroundVideos3>>,
      TError,
      { playlistPk: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistBackgroundVideos3>>,
  TError,
  { playlistPk: string; id: string },
  TContext
> => {
  const mutationOptions = getPlaylistBackgroundVideos3MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 여러 배경 영상을 한 번에 삭제합니다.
 * @summary 배경 영상 일괄 삭제
 */
export const playlistBulkDelete2 = (
  playlistPk: string,
  playlistBackgroundVideoBulkDeleteRequest: BodyType<PlaylistBackgroundVideoBulkDeleteRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/playlists/${playlistPk}/background-videos/bulk-delete/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: playlistBackgroundVideoBulkDeleteRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistBulkDelete2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistBulkDelete2>>,
    TError,
    {
      playlistPk: string;
      data: BodyType<PlaylistBackgroundVideoBulkDeleteRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistBulkDelete2>>,
  TError,
  {
    playlistPk: string;
    data: BodyType<PlaylistBackgroundVideoBulkDeleteRequest>;
  },
  TContext
> => {
  const mutationKey = ["playlistBulkDelete2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistBulkDelete2>>,
    {
      playlistPk: string;
      data: BodyType<PlaylistBackgroundVideoBulkDeleteRequest>;
    }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistBulkDelete2(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistBulkDelete2MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistBulkDelete2>>
>;
export type PlaylistBulkDelete2MutationBody =
  BodyType<PlaylistBackgroundVideoBulkDeleteRequest>;
export type PlaylistBulkDelete2MutationError = ErrorType<unknown>;

/**
 * @summary 배경 영상 일괄 삭제
 */
export const usePlaylistBulkDelete2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistBulkDelete2>>,
      TError,
      {
        playlistPk: string;
        data: BodyType<PlaylistBackgroundVideoBulkDeleteRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistBulkDelete2>>,
  TError,
  {
    playlistPk: string;
    data: BodyType<PlaylistBackgroundVideoBulkDeleteRequest>;
  },
  TContext
> => {
  const mutationOptions = getPlaylistBulkDelete2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 배경 영상의 순서를 변경합니다.

video_ids 배열에 영상 ID를 원하는 순서대로 전달하면 해당 순서로 정렬됩니다.
 * @summary 배경 영상 순서 변경
 */
export const playlistReorder3 = (
  playlistPk: string,
  playlistBackgroundVideoReorderRequest: BodyType<PlaylistBackgroundVideoReorderRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/playlists/${playlistPk}/background-videos/reorder/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: playlistBackgroundVideoReorderRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistReorder3MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistReorder3>>,
    TError,
    {
      playlistPk: string;
      data: BodyType<PlaylistBackgroundVideoReorderRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistReorder3>>,
  TError,
  { playlistPk: string; data: BodyType<PlaylistBackgroundVideoReorderRequest> },
  TContext
> => {
  const mutationKey = ["playlistReorder3"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistReorder3>>,
    {
      playlistPk: string;
      data: BodyType<PlaylistBackgroundVideoReorderRequest>;
    }
  > = (props) => {
    const { playlistPk, data } = props ?? {};

    return playlistReorder3(playlistPk, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistReorder3MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistReorder3>>
>;
export type PlaylistReorder3MutationBody =
  BodyType<PlaylistBackgroundVideoReorderRequest>;
export type PlaylistReorder3MutationError = ErrorType<unknown>;

/**
 * @summary 배경 영상 순서 변경
 */
export const usePlaylistReorder3 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistReorder3>>,
      TError,
      {
        playlistPk: string;
        data: BodyType<PlaylistBackgroundVideoReorderRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistReorder3>>,
  TError,
  { playlistPk: string; data: BodyType<PlaylistBackgroundVideoReorderRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistReorder3MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
